import React from 'react'
import Mhero1Hero from '../../components/pages/MHERO1/Mhero1Hero/Mhero1Hero'
import Warranty from '../../components/pages/MHERO1/Warranty/Warranty'
import TechnicalSpecs from '../../components/pages/MHERO1/TechnicalSpecs/TechnicalSpecs'
import ExteriorInteriorAccessories from '../../components/pages/MHERO1/Exterior/ExteriorInteriorAccessories'
import Features from '../../components/pages/MHERO1/Features/Features'
import Footer from '../../components/pages/MHERO1/Footer'
import BackToVehicleModels from '../../components/BackToVehicleModels/BackToVehicleModels'
import Mhero1Extras from '../../components/pages/MHERO1/Mhero1Extras/Mhero1Extras'

const Mhero1 = () => {
  return (
    <div>
        <Mhero1Hero/>
        <Warranty/>
        <TechnicalSpecs/>
        <ExteriorInteriorAccessories/>
        <Mhero1Extras/>
        <Features/>
        <BackToVehicleModels variant="dark" />
        <Footer/>
    </div>
  )
}

export default Mhero1